(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initialiseHomepageLinks() {
    var hero = document.querySelector('.mgh4');

    if (hero) {
      var giftFinderButton = hero.querySelector('.mgh4__btn--ghost');
      if (giftFinderButton) {
        giftFinderButton.setAttribute('href', '/pages/gift-finder');
        giftFinderButton.removeAttribute('data-scroll-to-concierge');
      }

      var conciergeLink = hero.querySelector('.mgh4__routes a[data-scroll-to-concierge]');
      if (conciergeLink) {
        conciergeLink.setAttribute('href', '#gift-concierge');

        if (conciergeLink.dataset.mgConciergeBound !== 'true') {
          conciergeLink.dataset.mgConciergeBound = 'true';
          conciergeLink.addEventListener('click', function (event) {
            var target = document.getElementById('gift-concierge');
            if (!target) return;

            event.preventDefault();
            target.scrollIntoView({
              behavior: prefersReducedMotion() ? 'auto' : 'smooth',
              block: 'start'
            });
          });
        }
      }
    }

    var explorePersonalisedGifts = document.querySelector('.mge5__button');
    if (explorePersonalisedGifts) {
      explorePersonalisedGifts.setAttribute('href', '/collections/all');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseHomepageLinks);
  } else {
    initialiseHomepageLinks();
  }

  document.addEventListener('shopify:section:load', initialiseHomepageLinks);
})();
